import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
declare const Swal;

@Component({
  selector: 'app-cab-assign',
  templateUrl: './cab-assign.component.html',
  styleUrls: ['./cab-assign.component.css']
})
export class CabAssignComponent implements OnInit {
  allNewVehicleList: any = [];
  userDetail: any;
  userInfo: any;
  selectedVehicleInfo: any;
  vehicleCheckIn: boolean;
  escortCheckIn: boolean;
  reOrderArr: any = [];
  reOrderGrp: any = {};
  
  @ViewChild('reOrderModalClose') reOrderModalClose: ElementRef;
  @ViewChild('mergeModalBtn') mergeModalBtn:ElementRef;
  @ViewChild('cabSearchBox') cabSearchBox: ElementRef;
  @ViewChild('groupSearchBox') groupSearchBox: ElementRef;
  @ViewChild('routeSearchBox') routeSearchBox: ElementRef;

  @Input() set isVehicleStatusChanged(val: any) {
    if (val) {
      this.getVehicleList();
    }
  }
  @Input() set filterDate(val: any) {
    if (val) {
      this.selFilteredDate = val;
      this.getEmployeeList(val);
    }
  }
  @Input() set branchChoosen(val: any) {
    if (val) {
      this.getBranchList();
      this.choosenBranch = val;
      if (this.selFilteredDate == undefined) {
        this.getEmployeeList();
      } else {
        this.getEmployeeList(this.selFilteredDate);
      }
      this.selectedVehicle = '';
      this.getVehicleList();
      this.getVehicleCheckInList();
    } else {
      this.choosenBranch = [];
    }
  }
  public checkInVehicles: any = [];
  public allCheckInVeh: any = [];
  public checkInOutID: string = '';
  public allCheck: boolean = false;
  public allIndeterminate: boolean = false;
  public routingData: any = [];
  public selectedGroupsObj: any = {};
  public availableEmpInGroups: any = [];
  public addEmpData: any = [];

  public disableAdd: boolean = true;
  public disableCreate: boolean = true;
  public disableMerge: boolean = true;
  public disableRemove: boolean = true;
  public availShiftTimes: any = [];

  public allVehicles: any = [];
  public branchInformation: any = {};
  public shiftInformation: any = [];
  public selectedBranch: any = [];
  public routedEmps: number = 0;
  public selTransMode: string = '';
  public selTripDate: string = '';
  public minDate: string;
  public cabAssignedData: any = [];
  public selFilteredDate: number;
  //Escort
  public checkInEscort: any = [];
  public searchEmps: any = [];
  public searchChangeObserver: any;
  public availableEscort: any = [];
  public escortCheckInOutID: any = '';
  public choosenBranch: any = [];

  public branchInfo: any = {};
  constructor(
    public storage: StorageService,
    public api: ApiService,
    public swal: SweetAlert,
    private com: CommonServices,
  ) {
    let today = new Date();
    this.minDate = this.formatDate(new Date(new Date().setDate(today.getDate() - 1)));
    if (this.storage.get('userInfo').branch && this.storage.get('userInfo').branch.length > 0) {
      this.selectedBranch = this.storage.get('userInfo').branch;
    }
    this.getBranchList();
    this.userDetail = this.storage.get('userInfo').fieldMap['Route / Rostering'].menu1['Roster'].menu2,
      this.userInfo = this.storage.get('userInfo')
    if ((this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].checked == false || this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].indeterminate == false) && this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].menu2['Vehicle Check In'].checked == false) {
      this.vehicleCheckIn = false;
    } else {
      this.vehicleCheckIn = true;
    }
    console.log("Vehicle Check In permission:", this.userDetail['Vehicle Check In']?.checked);
    console.log("vehicleCheckIn setting:", this.vehicleCheckIn);
    if ((this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].checked == false || this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].indeterminate == false) && this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].menu2['Escort Check In'].checked == false) {
      this.escortCheckIn = false;
    } else {
      this.escortCheckIn = true;
    }
  }

  ngOnInit(): void {
    // setTimeout(()=>{
    this.getVehicleList();
    // if(this.selFilteredDate==undefined){
    //   this.getEmployeeList();
    // }
    // },1000)
    if (this.checkInVehicles?.length) {
    this.allCabs = [...this.checkInVehicles];
    this.filteredCabs = [...this.allCabs];
  }
  }

  getBranchList() {
    let data = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(data).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          this.branchInformation[res.data[i]['branchID']] = res.data[i]['branchName'];
        }
        if (this.selectedBranch == undefined || this.selectedBranch.length <= 0) {
          this.selectedBranch = Object.keys(this.branchInformation)
        }
        let reqArr = res.data.filter(e => e.branchID == this.choosenBranch)
        this.branchInfo = {
          name: reqArr[0].branchName,
          location: reqArr[0].location,
          branchID: reqArr[0].branchID
        }
        this.getListShift();
        this.getEscortCheckInOutList();
      } else {
        this.selectedBranch = [];
        this.branchInformation = {};
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getListShift() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res && res.status == 'success' && res.data.length > 0) {
        let data = res.data;
        let arr = [];
        let shift = data.filter(e => e.branch == this.choosenBranch[0]);
        for (let j = 0; j < shift.length; j++) {
          arr.push(this.convertShiftTime(shift[j].startTime));
        }
        let shifts = this.removeDuplicateString(arr);
        this.shiftInformation = this.com.sortShifts(shifts);
      } else {
        this.shiftInformation = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  convertShiftTime(time) {
    let arr = time.split(':');
    if (Number(arr[0]) < 10 && arr[0]) {
      arr[0] = '0' + arr[0];
    }
    let timeString = arr.join(':');
    return timeString;
  }
  getVehicleList() {
    // Get Vehicle List API
    const obj = {
      "branch": this.choosenBranch
    };
    this.api.transportManagerOverallVehList(obj).then((res: any) => {
      this.allVehicles = [];
      if (res && res.status == 'success') {
        console.log("Vehicle Res::::", res);
        
        if (res && res['data'] && res['data'].length > 0) {
          this.allVehicles = res['data'];
          if (this.vehicleCheckIn == true) {
            this.getVehicleCheckInList();
          } else {
            this.getDriverList()
            this.checkInVehicles = [];
          }
        } else {
          this.allVehicles = [];
        }
console.log("Vehicle list::::", this.allVehicles);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getDriverList() {
    // Get drivers based on selected branch only
    const obj = {
      "branch": this.choosenBranch
    };
    
    this.api.transportManagerAllVehicleList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        console.log("allNewVehicleList API Response:", res);
        
        // API already filters by branch, so use the data directly
        if (res['data'] && res['data'].length > 0) {
          this.allNewVehicleList = res['data'];
        } else {
          this.allNewVehicleList = [];
        }
        console.log("Final allNewVehicleList:", this.allNewVehicleList);
        console.log("vehicleCheckIn status:", this.vehicleCheckIn);
      } else {
        console.log("API failed with status:", res?.status, res?.message);
        this.allNewVehicleList = [];
      }
    }).catch((err) => {
      console.log("API error:", err);
      this.allNewVehicleList = [];
    });
  }
  getVehicleCheckInList() {
    const obj = {
      "branch": this.choosenBranch,
      "type": ["out", "in"],
    };
    this.api.transportManagerCheckInOutList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res['data'].length > 0 && this.vehicleCheckIn == true) {
          this.allCheckInVeh = res.data;
          console.log("this checkInVehicles::::::::::::", this.allCheckInVeh);
          this.checkInVehicles = res.data.filter(e => e.type == 'in' && !e.routeAssign);
          // console.log("this checkInVehicles::::::::::::", this.checkInVehicles);
          
          this.loadCheckInVehicles();
          // this.checkInOutID=res['data'][0]['checkInOutID'];
        } else {
          this.checkInVehicles = [];
          this.checkInOutID = '';
          this.allCheckInVeh = [];
        }
        console.log("checkInVehicles:::::", this.checkInVehicles);
      } else {
        this.checkInVehicles = [];
        this.checkInOutID = '';
        this.allCheckInVeh = [];
      }
      
    }).catch((err) => {
      console.log(err);
    });
  }

  getEmployeeList(date?) {
    this.allCheck = false;
    this.allIndeterminate = false;
    //for empty vehicle selection
    this.selectedVehicle = '';
    this.selectedVehCapacity = 0;
    this.selectedGroupingCap = 0;
    this.routedEmps = 0;
    this.routingData = [];

    this.addEmpData = [];
    this.availableEmpInGroups = [];
    this.selectedGroupsObj = {};
    this.groupWithVehObj = {};
    this.groupWithoutVehObj = {};
    this.mergeDataAreas = {};
    this.selTransMode = '';
    this.selTripDate = '';
    let apiObj = {
      rosterStatus: ['Routing', 'Cab assign']
    };
    // if(this.storage.get('userInfo').userType!='admin'){
    // }
    apiObj['branchID'] = this.choosenBranch;
    // if(date){
    //   apiObj['tripDate']=date;
    // }else{
    //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    // }
    let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
    if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
      apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      apiObj['istoday'] = true;
    } else {
      apiObj['tripDate'] = this.selFilteredDate;
      apiObj['istoday'] = false;
    }

    this.api.transportManagerGrouping(apiObj).then(async (res: any) => {
      if (res && res.status == 'success') {
        if (res.data[0]['cabAssign'] && res.data[0]['cabAssign'].length > 0) {
          this.routingData = await this.com.sortGroupByShiftTime(res.data[0]['cabAssign'], 'shiftTime');
          this.cabAssignedData = res.data[0]['cabAssign'];
        } else {
          this.cabAssignedData = [];
        }
        if (res.data[0]['routing'] && res.data[0]['routing'].length > 0) {
          let assignedData: any = await this.com.sortGroupByShiftTime(res.data[0]['routing'], 'shiftTime');
          this.routingData = [...this.routingData, ...assignedData];
        }
        if (this.routingData.length > 0) {
          let shiftArr = [];
          this.availShiftTimes = [];
          for (let i = 0; i < this.routingData.length; i++) {
            shiftArr.push(this.routingData[i]['shiftTimeStr']);
          }
          this.availShiftTimes = this.removeDuplicateShifts(shiftArr);
          this.routedEmps = 0;
          for (let i = 0; i < this.routingData.length; i++) {
            this.routedEmps += this.routingData[i]['empInfo'].length;
          }

        } else {
          this.routedEmps = 0;
          this.availShiftTimes = [];
        }
        this.getGroupingData();
        //For Escort mandatory
        if (this.routingData.length > 0) {
          for (let i = 0; i < this.routingData.length; i++) {
            let emps = this.routingData[i].empInfo;
            for (let j = 0; j < emps.length; j++) {
              if (emps[j].gender == 'Female' && (this.convertTimeToDecimal(this.routingData[i].shiftTimeStr) >= 22 || this.convertTimeToDecimal(this.routingData[i].shiftTimeStr) <= 7)) {
                this.routingData[i]['isEscortNeed'] = true;
                break;
              }
            }
          }
        }
        
        // Create a separate copy of routingData for the modal, excluding assigned groups
        const unassignedGroups = this.routingData.filter(group => !group.vehRegNo);
        this.modalGroupsData = JSON.parse(JSON.stringify(unassignedGroups));
        this.filteredModalGroups = [...this.modalGroupsData];
      } else {
        this.cabAssignedData = [];
        this.routingData = [];
        this.modalGroupsData = [];
        this.filteredModalGroups = [];
        this.routedEmps = 0;
        this.availShiftTimes = [];
      }
    }).catch((err) => {
      console.log(err);
    });

    this.disableAdd = true;
    this.disableCreate = true;
    this.disableMerge = true;
    this.disableRemove = true;
    this.disableAssign = true;
  }
  getGroupingData() {
    let apiObj = {
      rosterStatus: ['Grouping']
    };
    // if(this.storage.get('userInfo').userType!='admin'){
    // }
    apiObj['branchID'] = this.choosenBranch;
    let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
    if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
      apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      apiObj['istoday'] = true;
    } else {
      apiObj['tripDate'] = this.selFilteredDate;
      apiObj['istoday'] = false;
    }
    this.api.transportManagerGrouping(apiObj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res.data[0]['grouping'] && res.data[0]['grouping'].length > 0) {
          this.storedGroupEmps = JSON.parse(JSON.stringify(res.data[0]['grouping']));
          this.findGroupEmps(res.data[0]['grouping']);
        } else {
          this.storedGroupEmps = [];
          this.groupingEmps = [];
          this.availableGroupEmps = [];
        }
      } else {
        this.storedGroupEmps = [];
        this.groupingEmps = [];
        this.availableGroupEmps = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  convertTimeToDecimal(time) {
    let num = Number(time.replace(':', '.'));
    return num;
  }
  removeDuplicateShifts(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }
  //Check box handling
  selectAllGroup(event) {
    this.allCheck = event;
    this.allIndeterminate = false;
    for (let i = 0; i < this.routingData.length; i++) {
      this.routingData[i].checked = event;
      this.routingData[i].indeterminate = false;
      if (this.routingData[i].empInfo && this.routingData[i].empInfo.length > 0) {
        let data = this.routingData[i];
        this.selectGroup(event, data.rosterID, data.routeID, i);
      }
    }
  }
  selectGroup(event, rosterId, routeID, index) {
    //merge
    if (event) {
      let data = {};
      data[rosterId] = this.routingData[index].empInfo;

      this.selectedGroupsObj = {
        ...this.selectedGroupsObj,
        ...data
      }
      if (this.routingData[index].assign) {
        this.groupWithVehObj = {
          ...this.groupWithVehObj,
          ...data
        }
      } else {
        this.groupWithoutVehObj = {
          ...this.groupWithoutVehObj,
          ...data
        }
      }
    } else {
      delete this.selectedGroupsObj[rosterId];
      //Un assign
      if (this.groupWithVehObj[rosterId]) {
        delete this.groupWithVehObj[rosterId];
      }
      if (this.groupWithoutVehObj[rosterId]) {
        delete this.groupWithoutVehObj[rosterId];
      }
    }
    this.routingData[index]['checked'] = event;
    this.routingData[index]['indeterminate'] = false;
    if (this.routingData[index]['empInfo'] && this.routingData[index]['empInfo'].length > 0) {
      let employee = this.routingData[index]['empInfo'];
      for (let i = 0; i < employee.length; i++) {
        employee[i].checked = event;
        employee[i].oldRosterID = rosterId;
        employee[i].routeID = routeID;
      }
      //For Add and Create
      if (event) {
        let arr1 = [...this.addEmpData, ...employee];
        this.addEmpData = this.removeDuplicates(arr1, 'empRefID');
        let arr2 = [...this.availableEmpInGroups, ...employee];
        this.availableEmpInGroups = this.removeDuplicates(arr2, 'empRefID');
      } else {
        for (let k = 0; k < employee.length; k++) {
          let index1 = this.addEmpData.findIndex(e => e.empRefID == employee[k].empRefID);
          if (index1 != -1) {
            this.addEmpData.splice(index1, 1);
          }
          let index2 = this.availableEmpInGroups.findIndex(e => e.empRefID == employee[k].empRefID);
          if (index2 != -1) {
            this.availableEmpInGroups.splice(index2, 1);
          }
        }
      }
    }
    this.checkAllGroupChecked();
  }
  selectEmployee(event, rosterId, routeID, empId, i) {
    let index = this.routingData[i]['empInfo'].findIndex(e => e.empRefID == empId);
    if (index != -1) {
      this.routingData[i]['empInfo'][index].checked = event;
      this.routingData[i]['empInfo'][index].oldRosterID = rosterId;
      this.routingData[i]['empInfo'][index].routeID = routeID;
    }
    if (event) {
      this.addEmpData.push(this.routingData[i]['empInfo'][index]);
    } else {
      let empIndex = this.addEmpData.findIndex(e => e.empRefID == empId);
      if (empIndex != -1) {
        this.addEmpData.splice(empIndex, 1);
      }
    }
    this.checkAllEmployeeChecked(event, rosterId, i);
    this.checkAllGroupChecked();
  }
  disableCheckBoxByClick(key) {
    this.selTransMode = '';
    this.selTripDate = '';
    let arr = [];
    for (let i = 0; i < this.routingData.length; i++) {
      if (this.routingData[i].checked || this.routingData[i].indeterminate) {
        let index = arr.findIndex(e => e == this.routingData[i][key]);
        if (index == -1) arr.push(this.routingData[i][key]);
      }
    }
    if (key == 'transitMode') {
      if (arr.length == 1) {
        this.selTransMode = arr[0];
      } else {
        this.selTransMode = '';
      }
    }
    if (key == 'tripDate') {
      if (arr.length == 1) {
        this.selTripDate = arr[0];
      } else {
        this.selTripDate = '';
      }
    }
  }
  checkAllEmployeeChecked(event, rosterId, index) {
    let employee = this.routingData[index]['empInfo'];
    let isValid = true;
    for (let i = 0; i < employee.length; i++) {
      if (employee[i].checked == false || employee[i].checked == undefined) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    let selStatus = false;
    let clickStatus = false;
    if (isValid) {
      this.routingData[index].checked = isValid;
      this.routingData[index].indeterminate = !isValid;

      let arr2 = [...this.availableEmpInGroups, ...employee];
      this.availableEmpInGroups = this.removeDuplicates(arr2, 'empRefID');
      //Merge
      let data = {};
      data[rosterId] = this.routingData[index].empInfo;

      this.selectedGroupsObj = {
        ...this.selectedGroupsObj,
        ...data
      }
      if (this.routingData[index].assign) {
        this.groupWithVehObj = {
          ...this.groupWithVehObj,
          ...data
        }
      } else {
        this.groupWithoutVehObj = {
          ...this.groupWithoutVehObj,
          ...data
        }
      }
      // else{
      //   this.isGroupWithVehSelected=false;
      //   this.isGroupWithoutVehSelected=true;
      // }
    } else {
      for (let k = 0; k < employee.length; k++) {
        let index2 = this.availableEmpInGroups.findIndex(e => e.empRefID == employee[k].empRefID);
        if (index2 != -1) {
          this.availableEmpInGroups.splice(index2, 1);
        }
      }
      //Merge
      delete this.selectedGroupsObj[rosterId];
      //Un assign
      if (this.groupWithVehObj[rosterId]) {
        delete this.groupWithVehObj[rosterId];
      }
      if (this.groupWithoutVehObj[rosterId]) {
        delete this.groupWithoutVehObj[rosterId];
      }

      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < employee.length; i++) {
        if (employee[i].checked) {
          checkArr.push('checked');
        } else if (employee[i].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      let group = this.routingData[index];
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        group.indeterminate = isValid;
        group.checked = isValid;
      } else if (checkArr.length == employee.length) {
        group.checked = !isValid;
        group.indeterminate = isValid;
      } else if (indeterArr.length == employee.length) {
        group.indeterminate = !isValid;
        group.checked = isValid;
      } else {
        group.indeterminate = !isValid;
        group.checked = isValid;
      }
      if (indeterArr.length > 1) {
        selStatus = true;
      } else {
        selStatus = false;
      }
      if (indeterArr.length > 0) {
        clickStatus = true;
      } else {
        clickStatus = false;
      }
    }
    this.disableCheckBoxByClick('transitMode');
    this.disableCheckBoxByClick('tripDate');
    if (this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length <= 0 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableCreate = false;
    } else {
      this.disableCreate = true;
    }
    if (this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.selectedGroupsObj).length == 1 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableAdd = false;
    } else {
      this.disableAdd = true;
    }
    // if((this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.selectedGroupsObj).length>1) 
    // || Object.keys(this.selectedGroupsObj).length>1){
    //   this.disableMerge=false;
    // }else{
    //   this.disableMerge=true;
    // }
    if (Object.keys(this.selectedGroupsObj).length > 1 && Object.keys(this.groupWithVehObj).length <= 1) {
      let groups = Object.keys(this.selectedGroupsObj);
      let empArr = [];
      for (let i = 0; i < groups.length; i++) {
        empArr = [...empArr, ...this.selectedGroupsObj[groups[i]]];
      }
      let allEmp = [];
      for (let a = 0; a < this.addEmpData.length; a++) {
        for (let b = 0; b < empArr.length; b++) {
          if (this.addEmpData[a].empRefID == empArr[b].empRefID) {
            allEmp.push(this.addEmpData[a]);
          }
        }
      }
      var is_same = this.addEmpData.length == allEmp.length && this.addEmpData.every(function (element, index) {
        return element['empRefID'] === allEmp[index]['empRefID'];
      })
      if (is_same && (this.selTransMode != '' || this.selTripDate != '')) {
        this.disableMerge = false;
      } else {
        this.disableMerge = true;
      }
    } else {
      this.disableMerge = true;
    }
    if (((this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length <= 0) ||
      (Object.keys(this.selectedGroupsObj).length > 0 && !selStatus && this.addEmpData.length == this.availableEmpInGroups.length)) &&
      Object.keys(this.groupWithVehObj).length <= 0) {
      this.disableRemove = false;
    } else {
      this.disableRemove = true;
    }
    if (((this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length == 1 && !clickStatus && this.selectedVehicle != '')) &&
      Object.keys(this.groupWithVehObj).length <= 0) {
      this.disableAssign = false;
    } else {
      this.disableAssign = true;
    }
    if (Object.keys(this.selectedGroupsObj).length == 1 && !clickStatus) {
      let key = Object.keys(this.selectedGroupsObj);
      this.selectedGroupingCap = this.selectedGroupsObj[key[0]].length;
    } else {
      this.selectedGroupingCap = 0;
    }
    if (Object.keys(this.groupWithVehObj).length > 0 && Object.keys(this.groupWithoutVehObj).length <= 0) {
      this.disableUnassign = false;
    } else {
      this.disableUnassign = true;
    }
  }

  checkAllGroupChecked() {
    let isValid = true;
    for (let i = 0; i < this.routingData.length; i++) {
      if (this.routingData[i].checked == false || this.routingData[i].checked == undefined) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    let selStatus = false;
    let clickStatus = false;
    if (isValid) {
      this.allCheck = isValid;
      this.allIndeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < this.routingData.length; i++) {
        if (this.routingData[i].checked) {
          checkArr.push('checked');
        } else if (this.routingData[i].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.allCheck = isValid;
        this.allIndeterminate = isValid;
      } else if (checkArr.length == this.routingData.length) {
        this.allCheck = !isValid;
        this.allIndeterminate = isValid;
      } else if (indeterArr.length == this.routingData.length) {
        this.allCheck = isValid;
        this.allIndeterminate = !isValid;
      } else {
        this.allCheck = isValid;
        this.allIndeterminate = !isValid;
      }
      if (indeterArr.length > 1) {
        selStatus = true;
      } else {
        selStatus = false;
      }
      if (indeterArr.length > 0) {
        clickStatus = true;
      } else {
        clickStatus = false;
      }
    }
    this.disableCheckBoxByClick('transitMode');
    this.disableCheckBoxByClick('tripDate');
    if (this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length <= 0 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableCreate = false;
    } else {
      this.disableCreate = true;
    }

    if (this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.selectedGroupsObj).length == 1 && (this.selTransMode != '' || this.selTripDate != '')) {
      this.disableAdd = false;
    } else {
      this.disableAdd = true;
    }
    // if((this.addEmpData.length != this.availableEmpInGroups.length && Object.keys(this.selectedGroupsObj).length>1) 
    // || Object.keys(this.selectedGroupsObj).length>1){
    //   this.disableMerge=false;
    // }else{
    //   this.disableMerge=true;
    // }
    if (Object.keys(this.selectedGroupsObj).length > 1 && Object.keys(this.groupWithVehObj).length <= 1) {
      let groups = Object.keys(this.selectedGroupsObj);
      let empArr = [];
      for (let i = 0; i < groups.length; i++) {
        empArr = [...empArr, ...this.selectedGroupsObj[groups[i]]];
      }
      let allEmp = [];
      for (let a = 0; a < this.addEmpData.length; a++) {
        for (let b = 0; b < empArr.length; b++) {
          if (this.addEmpData[a].empRefID == empArr[b].empRefID) {
            allEmp.push(this.addEmpData[a]);
          }
        }
      }
      var is_same = this.addEmpData.length == allEmp.length && this.addEmpData.every(function (element, index) {
        return element['empRefID'] === allEmp[index]['empRefID'];
      })
      if (is_same && (this.selTransMode != '' || this.selTripDate != '')) {
        this.disableMerge = false;
      } else {
        this.disableMerge = true;
      }
    } else {
      this.disableMerge = true;
    }
    if (((this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length <= 0) ||
      (Object.keys(this.selectedGroupsObj).length > 0 && !selStatus && this.addEmpData.length == this.availableEmpInGroups.length)) &&
      Object.keys(this.groupWithVehObj).length <= 0) {
      this.disableRemove = false;
    } else {
      this.disableRemove = true;
    }
    if (((this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length == 1 && !clickStatus && this.selectedVehicle != '') &&
      Object.keys(this.groupWithVehObj).length <= 0)) {
      this.disableAssign = false;
    } else {
      this.disableAssign = true;
    }
    if (Object.keys(this.selectedGroupsObj).length == 1 && !clickStatus) {
      let key = Object.keys(this.selectedGroupsObj);
      this.selectedGroupingCap = this.selectedGroupsObj[key[0]].length;
    } else {
      this.selectedGroupingCap = 0;
    }
    if (Object.keys(this.groupWithVehObj).length > 0 && Object.keys(this.groupWithoutVehObj).length <= 0) {
      this.disableUnassign = false;
    } else {
      this.disableUnassign = true;
    }
  }

  //Merge
  public mergeGroupForm: FormGroup;
  public mergeDataAreas: any = {};
  public showMergeForm: boolean = false;
  public mergeEmployees: any = [];
  public mergeFormSubmitted: boolean = false;
  public disableEmployee: boolean = false;
  public availMergeShifts: any = [];
  mergeGroups() {
    this.availMergeShifts = [];
    this.showMergeForm = true;
    document.getElementById('openMergeModalBtn')?.click();
    this.mergeFormLoad();
    this.mergeDataAreas = {};
    let rosterIds = Object.keys(this.selectedGroupsObj);
    let arr = [];
    for (let i = 0; i < rosterIds.length; i++) {
      let index = this.routingData.findIndex(e => e.rosterID == rosterIds[i]);
      if (index != -1) {
        this.mergeDataAreas[this.routingData[index].area] = rosterIds[i];
        arr.push(this.routingData[index].shiftTimeStr);
      }
    }
    let shifts = this.removeDuplicateString(arr);
    this.availMergeShifts = this.com.sortShifts(shifts);
    if (this.availMergeShifts.length == 1) {
      this.mergeGroupForm.controls['shiftTime'].patchValue(this.availMergeShifts[0]);
    }
  }
  mergeFormLoad() {
    this.mergeGroupForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl('', [Validators.required]),
    })
  }
  public mergeCheckError = (controlName: string, errorName: string) => {
    return this.mergeGroupForm.controls[controlName].hasError(errorName);
  }

  closeMerge() {
    this.mergeDataAreas = {};
    this.showMergeForm = false;
    this.mergeFormSubmitted = false;
    this.mergeModalBtn.nativeElement.click()
  }
  submitMerge() {
    this.mergeFormSubmitted = true;
    if (this.mergeGroupForm.valid) {
      //API call
      let rosterIds = Object.keys(this.selectedGroupsObj);
      let rosterIndex = rosterIds.findIndex(e => e == this.mergeGroupForm.value.area);
      if (rosterIndex != -1) {
        rosterIds.splice(rosterIndex, 1);
      }

      let obj = {
        tripDate: new Date(this.mergeGroupForm.value.tripDate).getTime(),
        // "tripDate":1683916200000,
        shiftTimeStr: this.mergeGroupForm.value.shiftTime,
        // shiftTimeStr:'17:00',
        rosterID: this.mergeGroupForm.value.area,
        type: 'Merge',
        oldRosterID: rosterIds,
        empInfo: this.addEmpData,
        branchInfo: this.branchInfo,
        routeID: this.addEmpData[0].routeID,
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.selectedGroupsObj = {};
          this.groupWithVehObj = {};
          this.groupWithoutVehObj = {};
          this.mergeDataAreas = {};
          document.getElementById('closeMergeBtn')?.click();
          this.routingData = {};
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.closeMerge();
          this.closeAddEmpForm();
          this.closeCreateEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  //Add
  public showAddForm: boolean = false;
  public addEmpForm: FormGroup;
  public addFormSubmitted: boolean = false;
  public addEmpArea: any = {};
  public addEmpShift: string = '';
  addEmployee() {
    this.addEmpFormLoad();
    document.getElementById('openAddModalBtn')?.click();
    // this.addEmpForm.controls['area'].patchValue(this.addEmpArea);
    this.showAddForm = true;
    this.addEmpArea = {};
    let rosterIds = Object.keys(this.selectedGroupsObj);
    for (let i = 0; i < rosterIds.length; i++) {
      let index = this.routingData.findIndex(e => e.rosterID == rosterIds[i]);
      if (index != -1) {
        this.addEmpArea[rosterIds[i]] = this.routingData[index].area;
        this.addEmpForm.controls['area'].patchValue(rosterIds[i]);
        this.addEmpShift = this.routingData[index].shiftTimeStr;
      }
    }
    this.addEmpForm.controls['shiftTime'].patchValue(this.addEmpShift);
    // this.addEmpArea=this.selectedGroupsObj[groups[0]].area;
  }
  addEmpFormLoad() {
    this.addEmpForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl('', [Validators.required]),
    })
  }

  
  // flags
public showRouteForm: boolean = false;

// selected items
public selectedVehicle: any = null;
public selectedGroup: any = null;
public routeList: any[] = [];
public assignmentCompleted = false;


public modalGroupsData: any = [];
public filteredModalGroups: any = [];
public currentModalGroupSearchTerm: string = '';

// open modal
openRoutePopup() {
  document.getElementById('openRouteModalBtn')?.click();
  this.showRouteForm = true;

  // Initialize cab lists for modal search from available vehicles
  this.allCabs = [...this.allNewVehicleList];
  this.filteredCabs = [...this.allCabs];

  // Ensure modal shows only unassigned items by filtering out assigned groups
  this.refreshModalData();

  // Reset all search fields and terms when opening the modal
  this.resetCabAndGroupSearch();
  this.resetRouteSearch();
}

// Helper method to refresh modal data and remove assigned items
private refreshModalData() {
  // Filter out groups that are already assigned (have vehRegNo)
  this.modalGroupsData = this.modalGroupsData.filter(group => !group.vehRegNo);
  this.filteredModalGroups = [...this.modalGroupsData];
  
  // Note: Vehicle lists should already be filtered from previous operations
  // but we can also ensure they don't have assigned vehicles
  this.filteredCabs = [...this.allCabs];
}

//new layout code

//   checkInVehiclesList = [
//   {
//     vehRegNo: 'TN98SI0001',
//     seatCapacity: 7
//   },
//   {
//     vehRegNo: 'TN98RS9090',
//     seatCapacity: 5
//   },
//   {
//     vehRegNo: 'TN98UY6666',
//     seatCapacity: 7
//   }
// ];
// select cab


selectCabVehicle(vehicle: any) {
  // toggle selection
  if (this.selectedVehicle && this.selectedVehicle.vehRegNo === vehicle.vehRegNo) {
    // unselect if already selected
    this.selectedVehicle = null;
    this.selectedVehCapacity = 0;
    this.selectedVehicleInfo = null;
  } else {
    // select new vehicle - store the entire vehicle object
    this.selectedVehicle = vehicle;
    this.selectedVehCapacity = vehicle.capacity || vehicle.seatCapacity;
    this.selectedVehicleInfo = vehicle;
  }

  this.checkAllGroupChecked();
}

isDisabled(vehicle: any): boolean {
  // disable other vehicles only while one is selected (before assign)
  return (
    (this.selectedVehicle &&
    this.selectedVehicle.vehRegNo !== vehicle.vehRegNo &&
    !this.assignmentCompleted
  ) || vehicle.assign == true
  )
}

isGroupDisabled(group: any): boolean {
  return (
    (this.selectedGroup &&
      this.selectedGroup.groupID !== group.groupID &&
      !this.assignmentCompleted) ||
    group.assign === true
  );
}

// select group
selectRouteGroup(group: any) {
  this.selectedGroup = group;
}


  assignRoute() {
    if (this.selectedVehicle && this.selectedGroup) {
      // Find complete vehicle info from allNewVehicleList
      let completeVehicleInfo = this.allNewVehicleList.find(v => v.vehRegNo === this.selectedVehicle.vehRegNo);
      
      // Debug logging
      // console.log('selectedVehicle:', this.selectedVehicle);
      // console.log('completeVehicleInfo:', completeVehicleInfo);
      // console.log('allNewVehicleList:', this.allNewVehicleList);
      
      const newRoute = {
        vehicle: {
          ...this.selectedVehicle,
          driverInfo: {
            name: completeVehicleInfo?.name || this.selectedVehicle.name || 'Unknown',
            mobile: completeVehicleInfo?.mobile || this.selectedVehicle.mobile || '0000000000',
            driverID: completeVehicleInfo?.driverID || this.selectedVehicle.driverID || 'unknown_driver'
          },
          vehInfo: {
            capacity: completeVehicleInfo?.capacity || this.selectedVehicle.capacity || this.selectedVehicle.seatCapacity || 6,
            vehType: completeVehicleInfo?.model || this.selectedVehicle.model || this.selectedVehicle.vehType || "SUV"
          }
        },
        group: this.selectedGroup,
        escort: this.selectedEscort
      };
      
      // Debug the created route
      console.log('newRoute created:', newRoute);

      // add to routeList
      this.routeList.push(newRoute);

      // also keep a master copy for searching
      this.allRoutes = [...this.routeList];
      this.filteredRoutes = [...this.allRoutes]; // refresh filtered list
      console.log("filteredRoutes::::", this.filteredRoutes);
      console.log("routeList::::::", this.routeList);
      // Remove assigned vehicle from modal vehicle lists
      this.allNewVehicleList = this.allNewVehicleList.filter(
        v => v.vehRegNo !== this.selectedVehicle.vehRegNo
      );
      
      this.allCabs = this.allCabs.filter(
        v => v.vehRegNo !== this.selectedVehicle.vehRegNo
      );

      if (this.currentCabSearchTerm) {
        this.filterCabs(this.currentCabSearchTerm);
      } else {
        this.filteredCabs = [...this.allCabs];
      }
      
      // Remove assigned group from modal lists
      this.modalGroupsData = this.modalGroupsData.filter(
        g => g.rosterID !== this.selectedGroup.rosterID
      );
      
      // Refresh filtered modal groups after removal
      if (this.currentModalGroupSearchTerm) {
        this.filterModalGroups(this.currentModalGroupSearchTerm);
      } else {
        this.filteredModalGroups = [...this.modalGroupsData];
      }

      this.assignmentCompleted = true;

      // reset selections
      this.selectedVehicle = null;
      this.selectedGroup = null;
      this.selectedRoute = null;
      // this.selectedEscort = null;

      // Clear cab and group search fields after successful assign
      this.resetCabAndGroupSearch();

      setTimeout(() => {
        this.assignmentCompleted = false;
      }, 0);
    }
  }

  // Bulk assign all routes in filteredRoutes
  bulkAssignRoutes() {
    if (this.filteredRoutes.length === 0) {
      this.swal.swalFunction('warning', 'Warning', 'No routes to assign. Please assign vehicles to groups first.', 5000);
      return;
    }

    Swal.fire({
      title: 'Confirm Bulk Assignment',
      text: `Are you sure you want to assign route(s)`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50',
      confirmButtonText: `Yes, assign route(s)`,
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.processBulkAssignment();
        
      }
    });
  }



  // Process the bulk assignment
  private processBulkAssignment() {
    const assigningDetails = [];

    for (let route of this.filteredRoutes) {
      // Debug route data
      console.log('Processing route:', route);
      console.log('route.vehicle:', route.vehicle);
      console.log('route.vehicle.vehInfo:', route.vehicle.vehInfo);
      console.log('route.vehicle.driverInfo:', route.vehicle.driverInfo);
      
      // Ensure driverInfo and vehInfo exist
      const driverInfo = route.vehicle.driverInfo || {
        name: route.vehicle.name ,
        mobile: route.vehicle.mobile,
        driverID: route.vehicle.driverID
      };
      
      const vehInfo = route.vehicle.vehInfo || {
        capacity: route.vehicle.capacity,
        vehType: route.vehicle.model 
      };
      
      let assignmentObj = {
        rosterID: route.group.rosterID,
        driverName: driverInfo.name,
        driverMobile: driverInfo.mobile,
        driverID: driverInfo.driverID,
        vehRegNo: route.vehicle.vehRegNo,
        driverInfo: {
          name: driverInfo.name,
          mobile: driverInfo.mobile,
          driverID: driverInfo.driverID
        },
        vehInfo: {
          capacity: vehInfo.capacity,
          vehType: vehInfo.vehType
        }
      };

      assigningDetails.push(assignmentObj);
    }

    // Create bulk assignment payload matching your structure
    const cabAssignObj = {
      type: "multi Cab Assign",
      tripDate: this.selTripDate || new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime(),
      assigningDetails: assigningDetails
    };

    // Call the bulk assignment API
    this.api.transportManagerBulkCabAssignment(cabAssignObj).then((res: any) => {
      if (res && res.status === 'success') {
        this.swal.swalFunction('success', res.status, `Successfully assigned ${this.filteredRoutes.length} route(s)!`, 5000);
        
        // Refresh vehicle and employee lists
        this.getVehicleList();
        this.getVehicleCheckInList();
            this.selectedVehicle = '';

        // Store assigned group and vehicle IDs to exclude from modal after refresh
        const assignedGroupIds = this.filteredRoutes.map(route => route.group.rosterID);
        const assignedVehicleIds = this.filteredRoutes.map(route => route.vehicle.vehRegNo);
        
        // Remove assigned routes from the lists
        for (let assignedRoute of this.filteredRoutes) {
          // Remove from routeList
          const routeIndex = this.routeList.findIndex(r => r.group.rosterID === assignedRoute.group.rosterID);
          if (routeIndex > -1) {
            this.routeList.splice(routeIndex, 1);
          }
        }
        
        // Update master lists
        this.allRoutes = [...this.routeList];
        this.filteredRoutes = [...this.allRoutes];
        
        
        
        if (this.selFilteredDate === undefined) {
          this.getEmployeeList();
        } else {
          this.getEmployeeList(this.selFilteredDate);
        }
        
        // After data refresh, remove assigned items from modal lists
        setTimeout(() => {
          // Remove assigned groups from modal lists
          this.modalGroupsData = this.modalGroupsData.filter(
            group => !assignedGroupIds.includes(group.rosterID)
          );
          this.filteredModalGroups = [...this.modalGroupsData];
          
          // Remove assigned vehicles from modal lists
          this.allNewVehicleList = this.allNewVehicleList.filter(
            vehicle => !assignedVehicleIds.includes(vehicle.vehRegNo)
          );
          this.allCabs = this.allCabs.filter(
            vehicle => !assignedVehicleIds.includes(vehicle.vehRegNo)
          );
          this.filteredCabs = [...this.allCabs];
        }, 100);
        
        // Reset selections
        this.selectedVehicle = null;
        this.selectedGroup = null;
        this.selectedRoute = null;

        this.refreshVehicleList();

        // Reset all search fields and filters after successful submit
        this.resetCabAndGroupSearch();
        this.resetRouteSearch();

        // ✅ Automatically close the modal after short delay
        setTimeout(() => {
          const closeBtn = document.querySelector('[data-dismiss="modal"]') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }, 600);
      } else {
        this.swal.swalFunction('error', res.status || 'Error', res.message || 'Failed to assign routes', 5000);
      }
    }).catch((err) => {
      console.error('Bulk assignment error:', err);
      this.swal.swalFunction('error', 'Error', 'An error occurred while assigning routes', 5000);
    });
  }
hoveredGroup: any = null;

showEmpList(group: any) {
  this.hoveredGroup = group;
}

hideEmpList() {
  this.hoveredGroup = null;
}

hoveredRoute: any = null;

showEmpRouteList(route: any) {
  this.hoveredRoute = route;

}

hideEmpRouteList() {
  this.hoveredRoute = null;
}



getEmployeeListTooltip(group: any): string {
  if (!group || !group.empInfo || group.empInfo.length === 0) {
    return 'No employees in this group';
  }

  return group.empInfo
    .map(
      (emp: any, i: number) =>
        `${i + 1}. ${emp.name || '---'} | ${emp.empRefID || '---'} | ${emp.gender || '---'}`
    )
    .join('\n');
}

// revert back from route list
// revertSelectedRoute() {
//   if (this.selectedRoute) {
//     // find index of the selected route
//     const index = this.routeList.findIndex(r => r === this.selectedRoute);

//     if (index > -1) {
//       // remove from routeList
//       const [route] = this.routeList.splice(index, 1);

//       // add back to original lists
//       this.checkInVehiclesList.push(route.vehicle);
//       this.routingData.push(route.group);

//       // clear selection if needed
//       this.selectedRoute = null;
//     }
//   }
// }

currentCabSearchTerm: string = '';
allCabs: any[] = [];       // will hold full API list
filteredCabs: any[] = [];  // filtered list for display

// Call this after fetching API data
loadCheckInVehicles() {
  this.api.transportManagerCheckInOutList({ branch: this.choosenBranch, type: ["out", "in"] })
    .then((res: any) => {
      console.log("static cabs::::", res);
      
      if (res.status === 'success' && res.data?.length > 0) {
        this.allCabs = res.data.filter(e => e.type == 'in' && !e.routeAssign);
        this.filteredCabs = [...this.allCabs]; // copy full list initially
      } else {
        this.allCabs = [];
        this.filteredCabs = [];
      }
    })
    .catch(err => console.error(err));
}

// Search filter
// filterCabs(searchTerm: string) {

//   this.currentCabSearchTerm = searchTerm; 
//   if (!searchTerm) {
//     this.filteredCabs = [...this.allCabs]; // reset
//     return;
//   }
//   searchTerm = searchTerm.toLowerCase();
//   console.log("this.allcabs:::::::", this.allCabs);
//   this.filteredCabs = this.allCabs.filter(veh =>
//     veh.vehRegNo.toLowerCase().includes(searchTerm) ||
//     String(veh.seatCapacity).includes(searchTerm) // also allow searching by seat capacity
//   );
// }

filterCabs(searchTerm: string) {
  this.currentCabSearchTerm = searchTerm;

  if (!searchTerm) {
    this.filteredCabs = [...this.allCabs];
    return;
  }

  const term = searchTerm.trim().toLowerCase();

  this.filteredCabs = this.allCabs.filter(veh => {
    const regNo = veh && veh.vehRegNo ? veh.vehRegNo.toLowerCase() : '';

    let capacityValue: any = '';
    if (veh && veh.capacity !== null && veh.capacity !== undefined) {
      capacityValue = veh.capacity;
    } else if (veh && veh.seatCapacity !== null && veh.seatCapacity !== undefined) {
      capacityValue = veh.seatCapacity;
    } else if (veh && veh.vehInfo && veh.vehInfo.capacity !== null && veh.vehInfo.capacity !== undefined) {
      capacityValue = veh.vehInfo.capacity;
    }

    const capacity = String(capacityValue);

    return regNo.includes(term) || capacity.includes(term);
  });
}


// Filter modal groups by area, shift time, or transit mode
filterModalGroups(searchTerm: string) {
  this.currentModalGroupSearchTerm = searchTerm;
  if (!searchTerm) {
    this.filteredModalGroups = [...this.modalGroupsData]; // reset
    return;
  }
  searchTerm = searchTerm.toLowerCase();
  this.filteredModalGroups = this.modalGroupsData.filter(group =>
    group.area.toLowerCase().includes(searchTerm) ||
    group.shiftTimeStr.toLowerCase().includes(searchTerm) ||
    group.transitMode.toLowerCase().includes(searchTerm)
  );
}

allRoutes: any[] = [];       // will hold full API route list
filteredRoutes: any[] = [];  // filtered list for display


currentSearchTerm: string = '';
// Filter by area name or shift time
filterRoutes(searchTerm: string) {
  this.currentSearchTerm = searchTerm; 
  if (!searchTerm) {
    this.filteredRoutes = [...this.allRoutes]; // reset when empty
    return;
  }
  searchTerm = searchTerm.toLowerCase();
  this.filteredRoutes = this.allRoutes.filter(route =>
    route.group.area.toLowerCase().includes(searchTerm) ||
    route.group.shiftTimeStr.toLowerCase().includes(searchTerm) ||
    route.group.transitMode.toLowerCase().includes(searchTerm)

  );
  // console.log("filteredRoutes::::", this.filteredRoutes);
  
}

resetCabAndGroupSearch() {
  // Clear cab & group search terms and reset filtered lists
  this.currentCabSearchTerm = '';
  this.currentModalGroupSearchTerm = '';

  this.filteredCabs = [...this.allCabs];
  this.filteredModalGroups = [...this.modalGroupsData];

  if (this.cabSearchBox && this.cabSearchBox.nativeElement) {
    this.cabSearchBox.nativeElement.value = '';
  }
  if (this.groupSearchBox && this.groupSearchBox.nativeElement) {
    this.groupSearchBox.nativeElement.value = '';
  }
}

resetRouteSearch() {
  // Clear "Cabs Assigned" search term and reset filtered routes
  this.currentSearchTerm = '';
  this.filteredRoutes = [...this.allRoutes];

  if (this.routeSearchBox && this.routeSearchBox.nativeElement) {
    this.routeSearchBox.nativeElement.value = '';
  }
}

revertRoute(routeToRemove: any) {
  // remove from routeList
  this.routeList = this.routeList.filter(r => r !== routeToRemove);

  // sync master list
  this.allRoutes = [...this.routeList];

  // re-apply current search (or reset if no search)
  if (this.currentSearchTerm) {
    this.filterRoutes(this.currentSearchTerm);
  } else {
    this.filteredRoutes = [...this.allRoutes];
  }

  // also add vehicle & group back to available lists
  this.checkInVehicles.push(routeToRemove.vehicle);
  this.routingData.push(routeToRemove.group);
  
  // Restore vehicle to modal vehicle lists
  const existingModalVehicle = this.allNewVehicleList.find(
    v => v.vehRegNo === routeToRemove.vehicle.vehRegNo
  );
  if (!existingModalVehicle) {
    this.allNewVehicleList.push(routeToRemove.vehicle);
  }
  
  const existingModalCab = this.allCabs.find(
    v => v.vehRegNo === routeToRemove.vehicle.vehRegNo
  );
  if (!existingModalCab) {
    this.allCabs.push(routeToRemove.vehicle);
    // Refresh filtered cabs
    if (this.currentCabSearchTerm) {
      this.filterCabs(this.currentCabSearchTerm);
    } else {
      this.filteredCabs = [...this.allCabs];
    }
  }
  
  // Also restore group to modalGroupsData if it doesn't exist
  const existingModalGroup = this.modalGroupsData.find(
    g => g.rosterID === routeToRemove.group.rosterID
  );
  if (!existingModalGroup) {
    routeToRemove.group.assign = false;
    this.modalGroupsData.push(routeToRemove.group);
    // Refresh filtered modal groups
    if (this.currentModalGroupSearchTerm) {
      this.filterModalGroups(this.currentModalGroupSearchTerm);
    } else {
      this.filteredModalGroups = [...this.modalGroupsData];
    }
  }
}


revertSelectedRoute() {
  if (!this.selectedRoute) return;

  const routeToRemove = this.selectedRoute;

  // Remove from routeList
  this.routeList = this.routeList.filter(r => r !== routeToRemove);

  // Update master route lists
  this.allRoutes = [...this.routeList];
  this.filteredRoutes = [...this.allRoutes];

  // Restore cab back to modal vehicle lists
  routeToRemove.vehicle.assign = false;
  
  // Add back to allNewVehicleList if not already there
  const existingModalVehicle = this.allNewVehicleList.find(
    v => v.vehRegNo === routeToRemove.vehicle.vehRegNo
  );
  if (!existingModalVehicle) {
    this.allNewVehicleList.push(routeToRemove.vehicle);
  }
  
  // Add back to allCabs if not already there
  const existingModalCab = this.allCabs.find(
    v => v.vehRegNo === routeToRemove.vehicle.vehRegNo
  );
  if (!existingModalCab) {
    this.allCabs.push(routeToRemove.vehicle);
  }

  // Re-apply cab search so cab appears instantly
  if (this.currentCabSearchTerm) {
    this.filterCabs(this.currentCabSearchTerm);
  } else {
    this.filteredCabs = [...this.allCabs];
  }

  const existingGroup = this.routingData.find(
    g => g.rosterID === routeToRemove.group.rosterID
  );

  if (existingGroup) {
    // Group already exists in the list → just mark it unassigned
    existingGroup.assign = false;
  } else {
    // Only add back if it was actually removed earlier
    routeToRemove.group.assign = false;
    this.routingData.push(routeToRemove.group);
  }
  
  // Also handle modalGroupsData
  const existingModalGroup = this.modalGroupsData.find(
    g => g.rosterID === routeToRemove.group.rosterID
  );
  
  if (existingModalGroup) {
    // Group already exists in modal data → just mark it unassigned
    existingModalGroup.assign = false;
  } else {
    // Add back to modal data if it doesn't exist
    routeToRemove.group.assign = false;
    this.modalGroupsData.push(routeToRemove.group);
  }
  
  // Refresh filtered modal groups
  if (this.currentModalGroupSearchTerm) {
    this.filterModalGroups(this.currentModalGroupSearchTerm);
  } else {
    this.filteredModalGroups = [...this.modalGroupsData];
  }

  // Restore group back to routingData
  // this.routingData.push(routeToRemove.group);

  // Reset selection
  this.selectedRoute = null;
}

revertAllRoutes() {
  if (!this.routeList || this.routeList.length === 0) return;

  // Loop through all assigned routes
  this.routeList.forEach(route => {
    // Restore vehicle
    route.vehicle.assign = false;

    // Add back to modal vehicle list if not already there
    if (!this.allNewVehicleList.find(v => v.vehRegNo === route.vehicle.vehRegNo)) {
      this.allNewVehicleList.push(route.vehicle);
    }

    // Add back to all cabs if not already there
    if (!this.allCabs.find(v => v.vehRegNo === route.vehicle.vehRegNo)) {
      this.allCabs.push(route.vehicle);
    }

    // Restore group in routingData
    const existingGroup = this.routingData.find(g => g.rosterID === route.group.rosterID);
    if (existingGroup) {
      existingGroup.assign = false;
    } else {
      route.group.assign = false;
      this.routingData.push(route.group);
    }

    // Restore group in modalGroupsData
    const existingModalGroup = this.modalGroupsData.find(g => g.rosterID === route.group.rosterID);
    if (existingModalGroup) {
      existingModalGroup.assign = false;
    } else {
      route.group.assign = false;
      this.modalGroupsData.push(route.group);
    }
  });

  // Finally, clear route list
  this.routeList = [];
  this.allRoutes = [];
  this.filteredRoutes = [];

  this.selectedRoute = null;
  this.refreshVehicleList();

  // Reset all search fields and filters when closing the modal
  this.resetCabAndGroupSearch();
  this.resetRouteSearch();
}

  public addCheckError = (controlName: string, errorName: string) => {
    return this.addEmpForm.controls[controlName].hasError(errorName);
  }
  submitAddEmployee() {
    this.addFormSubmitted = true;
    if (this.addEmpForm.valid) {
      let obj = {
        type: 'Add',
        tripDate: new Date(this.addEmpForm.value.tripDate).getTime(),
        shiftTimeStr: this.addEmpForm.value.shiftTime,
        // "tripDate":1683916200000,
        // shiftTimeStr:'17:00',
        rosterID: this.addEmpForm.value.area,
        empInfo: this.addEmpData,
        branchInfo: this.branchInfo,
        routeID: this.addEmpData[0].routeID,
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.selectedGroupsObj = {};
          this.groupWithVehObj = {};
          this.groupWithoutVehObj = {};
          this.mergeDataAreas = {};
          document.getElementById('closeAddBtn')?.click();
          this.routingData = {};
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.closeMerge();
          this.closeAddEmpForm();
          this.closeCreateEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeAddEmpForm() {
    this.showAddForm = false;
    this.addFormSubmitted = false;
    this.addEmpShift = '';
  }
  public selectedEmpCount: number = 0;

  //For Create
  public showCreateForm: boolean = false;
  public createEmpForm: FormGroup;
  public createFormSubmitted: boolean = false;
  public createEmpData: any = [];
  public empsLoc: any = [];
  openCreateEmployee() {
    this.empsLoc = [];
    let arr = [];
    for (let i = 0; i < this.addEmpData.length; i++) {
      for (let j = 0; j < this.routingData.length; j++) {
        let data = this.routingData[j]['empInfo'].filter(e => e.empRefID == this.addEmpData[i].empRefID);
        if (data.length > 0) {
          arr.push(data[0].area);
        }
      }
    }
    this.empsLoc = this.removeDuplicateString(arr);
    this.createEmpFormLoad();
    document.getElementById('openCreateModalBtn')?.click();
    // this.addEmpForm.controls['area'].patchValue(this.addEmpArea);
    this.showCreateForm = true;
  }


  removeDuplicateString(arr) {
    return arr.filter((item,
      index) => arr.indexOf(item) === index);
  }
  createEmpFormLoad() {
    this.createEmpForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl(this.empsLoc[0], [Validators.required]),
    })
  }
  public createCheckError = (controlName: string, errorName: string) => {
    return this.createEmpForm.controls[controlName].hasError(errorName);
  }
  submitCreateEmployee() {
    this.createFormSubmitted = true;
    if (this.createEmpForm.valid) {
      let obj = {
        type: 'Create',
        tripDate: new Date(this.createEmpForm.value.tripDate).getTime(),
        shiftTimeStr: this.createEmpForm.value.shiftTime,
        // "tripDate":1683916200000,
        // shiftTimeStr:'17:00',
        area: this.createEmpForm.value.area,
        empInfo: this.addEmpData,
        tripType: this.addEmpData[0].tripType,
        routeID: this.addEmpData[0].routeID,
        branchInfo: this.branchInfo
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.selectedGroupsObj = {};
          this.groupWithVehObj = {};
          this.groupWithoutVehObj = {};
          this.mergeDataAreas = {};
          document.getElementById('closeCreateBtn')?.click();
          this.routingData = {};
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.closeMerge();
          this.closeAddEmpForm();
          this.closeCreateEmpForm();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeCreateEmpForm() {
    this.showCreateForm = false;
    this.createFormSubmitted = false;
  }

  //For Remove
  public showRemoveForm: boolean = false;
  public removeFormSubmitted: boolean = false;
  public removeEmpForm: FormGroup;

  openRemoveEmployee() {
    if (this.addEmpData.length > 0 && Object.keys(this.selectedGroupsObj).length <= 0) {
      this.empsLoc = [];
      let arr = [];
      for (let i = 0; i < this.addEmpData.length; i++) {
        for (let j = 0; j < this.routingData.length; j++) {
          let data = this.routingData[j]['empInfo'].filter(e => e.empRefID == this.addEmpData[i].empRefID);
          if (data.length > 0) {
            arr.push(data[0].area);
          }
        }
      }
      this.empsLoc = this.removeDuplicateString(arr);
      this.removeEmpFormLoad();
      document.getElementById('openRemoveModalBtn')?.click();
      this.showRemoveForm = true;
    } else if (Object.keys(this.selectedGroupsObj).length > 0 && this.addEmpData.length == this.availableEmpInGroups.length) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to re-group the selected group!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      }).then((result) => {
        if (result.isConfirmed) {
          let rosterIds = Object.keys(this.selectedGroupsObj);
          let obj = {
            type: 'Back to grouping',
            rosterID: rosterIds,
            branchInfo: this.branchInfo,
            tripDate: this.selTripDate
            // tripDate:this.selFilteredDate
          }
          // if(this.selFilteredDate==undefined){
          //   obj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
          // }else{
          //   obj['tripDate']=this.selFilteredDate;
          // }
          this.api.transportManagerEditGrouping(obj).then((res: any) => {
            if (res && res.status == 'success') {
              this.swal.swalFunction('success', res.status, res.message, 5000);
              this.selectedGroupsObj = {};
              this.groupWithVehObj = {};
              this.groupWithoutVehObj = {};
              this.mergeDataAreas = {};
              this.addEmpData = [];
              this.availableEmpInGroups = [];
              this.getVehicleCheckInList();
              if (this.selFilteredDate == undefined) {
                this.getEmployeeList();
              } else {
                this.getEmployeeList(this.selFilteredDate);
              }
            } else {
              this.swal.swalFunction('error', res.status, res.message, 5000);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      });
    }
  }
  removeEmpFormLoad() {
    this.removeEmpForm = new FormGroup({
      tripDate: new FormControl(this.com.timestampToDate(this.selTripDate, 'YMD', '-'), [Validators.required]),
      shiftTime: new FormControl('', [Validators.required]),
      area: new FormControl(this.empsLoc[0], [Validators.required]),
    })
  }
  public removeCheckError = (controlName: string, errorName: string) => {
    return this.removeEmpForm.controls[controlName].hasError(errorName);
  }
  submitRemove() {
    this.removeFormSubmitted = true;
    if (this.removeEmpForm.valid) {
      let obj = {
        type: 'Remove',
        tripDate: new Date(this.removeEmpForm.value.tripDate).getTime(),
        shiftTimeStr: this.removeEmpForm.value.shiftTime,
        // "tripDate":1683916200000,
        // shiftTimeStr:'17:00',
        area: this.removeEmpForm.value.area,
        empInfo: this.addEmpData,
        tripType: this.addEmpData[0].tripType,
        branchInfo: this.branchInfo,
        routeID: this.addEmpData[0].routeID,
      }
      this.api.transportManagerEditGrouping(obj).then((res: any) => {
        if (res && res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 5000);
          this.selectedGroupsObj = {};
          this.groupWithVehObj = {};
          this.groupWithoutVehObj = {};
          this.mergeDataAreas = {};
          this.addEmpData = [];
          this.availableEmpInGroups = [];
          this.disableRemove = true;
          document.getElementById('closeRemoveBtn')?.click();
          this.closeRemoveEmpForm();
          this.getVehicleCheckInList();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  closeRemoveEmpForm() {
    this.showRemoveForm = false;
    this.removeFormSubmitted = false;
  }
  // public selectedVehicle: string = '';
  public disableAssign: boolean = true;
  public selectedVehCapacity: number = 0;
  public selectedGroupingCap: number = 0;
  triggerVehicle(id) {
    // console.log(id,document.getElementById('veh'+id))
    document.getElementById('veh' + id)?.click();
  }
  selectVehicle(e, vehicle) {
    if (e) {
      this.selectedVehicle = vehicle.vehRegNo;
      this.selectedVehCapacity = vehicle.capacity;
      this.selectedVehicleInfo = vehicle;
    } else {
      this.selectedVehicle = '';
      this.selectedVehCapacity = 0;
    }
    this.checkAllGroupChecked();
  }
  assignVehicle() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to assign this vehicle to selected group!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50 ',
      confirmButtonText: 'Assign',
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let keys = Object.keys(this.selectedGroupsObj);
        let rosterID = keys[0];
        let obj = {};
        if ((this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].checked == true || this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].indeterminate == true) && this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].menu2['Vehicle Check In'].checked == true && this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].menu2['Vehicle Check Out'].checked == true) {
          let selVeh = this.checkInVehicles.filter(e => e.vehRegNo == this.selectedVehicle);

          obj = {
            rosterID: rosterID,
            // tripDate:this.selFilteredDate,
            // tripDate:1683916200000,
            type: "Cab assign",
            driverName: selVeh[0].driverInfo.name,
            driverMobile: selVeh[0].driverInfo.mobile,
            driverID: selVeh[0]['driverInfo']['driverID'],
            vehRegNo: this.selectedVehicle,
            date: selVeh[0].checkIn.date,
            checkInID: selVeh[0].checkInID,
            driverInfo: selVeh[0].driverInfo,
            // capacity:selVeh[0].capacity,
            vehInfo: {
              capacity: selVeh[0]['vehInfo'].capacity,
              vehType: selVeh[0]['vehInfo'].vehType,
              checkInID: selVeh[0].checkInID,
            },
            branchInfo: this.branchInfo,
            tripDate: this.selTripDate
          }
        } else {
          let checkinDate = new Date()
          checkinDate.setHours(0, 0, 0, 0)
          obj = {
            rosterID: rosterID,
            type: "Cab assign",
            driverName: this.selectedVehicleInfo.name,
            driverMobile: this.selectedVehicleInfo.mobile,
            driverID: this.selectedVehicleInfo['driverID'],
            vehRegNo: this.selectedVehicle,
            date: checkinDate.getTime(),
            checkInID: this.selectedVehicleInfo.checkInID,
            driverInfo: {
              name: this.selectedVehicleInfo.name,
              mobile: this.selectedVehicleInfo.mobile,
              driverID: this.selectedVehicleInfo['driverID']
            },
            vehInfo: {
              capacity: this.selectedVehicleInfo.capacity,
              vehType: this.selectedVehicleInfo.model,
              checkInID: this.selectedVehicleInfo.checkInID,
            },
            branchInfo: this.branchInfo,
            tripDate: this.selTripDate
          }
        }
        // if(this.selFilteredDate==undefined){
        //   obj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
        // }else{
        //   obj['tripDate']=this.selFilteredDate;
        // }
        this.api.transportManagerEditGrouping(obj).then((res: any) => {
          if (res && res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 5000);
            this.selectedGroupsObj = {};
            this.groupWithVehObj = {};
            this.groupWithoutVehObj = {};
            this.mergeDataAreas = {};
            this.addEmpData = [];
            this.availableEmpInGroups = [];
            this.getVehicleList();
            this.getVehicleCheckInList();
            this.selectedVehicle = '';
            this.selectedVehCapacity = 0;
            this.selectedGroupingCap = 0;
            if (this.selFilteredDate == undefined) {
              this.getEmployeeList();
            } else {
              this.getEmployeeList(this.selFilteredDate);
            }
          } else {
            this.swal.swalFunction('error', res.status, res.message, 5000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }

  //Confirm
  moveGroupToFleet(group) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to confirm a route? Notifications will be triggered for both employees and driver.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50 ',
      confirmButtonText: 'Confirm',
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          rosterID: group.rosterID,
          // tripDate:this.selFilteredDate,
          // type:"Fleet management",
          type: "Push notification",
          empInfo: group.empInfo,
          branchInfo: this.branchInfo,
          tripDate: group.tripDate
        }
        // if(this.selFilteredDate==undefined){
        //   obj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
        // }else{
        //   obj['tripDate']=this.selFilteredDate;
        // }
        this.api.transportManagerEditGrouping(obj).then((res: any) => {
          if (res && res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 5000);
            this.getVehicleCheckInList();
            if (this.selFilteredDate == undefined) {
              this.getEmployeeList();
            } else {
              this.getEmployeeList(this.selFilteredDate);
            }
          } else {
            this.swal.swalFunction('error', res.status, res.message, 5000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }
  refreshVehicleList() {
    this.selectedVehicle = '';
    this.vehicleCheckIn ? this.getVehicleCheckInList() : this.getVehicleList();

  }

  //Un assign
  public disableUnassign: boolean = true;
  public isGroupWithVehSelected: boolean = false;
  public isGroupWithoutVehSelected: boolean = false;
  public groupWithVehObj: any = {};
  public groupWithoutVehObj: any = {};
  openUnAssignVehicle() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to un assign the vehicle from this group!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Confirm'
    }).then((result) => {
      if (result.isConfirmed) {
        let rosterIDs = Object.keys(this.groupWithVehObj);
        let arr = [];
        for (let i = 0; i < rosterIDs.length; i++) {
          let group = this.routingData.filter(e => e.rosterID == rosterIDs[i]);
          let vehicle = group[0].vehRegNo;
          let obj = {}
          if (this.vehicleCheckIn) {
            let data = this.allCheckInVeh.filter(e => e.vehRegNo == vehicle);
            if (data.length > 0) {
              obj = {
                vehRegNo: data[0].vehRegNo,
                date: data[0].checkIn.date,
                checkInID: data[0].checkInID,
              }
              arr.push(obj);
            }
          } else {
            obj = {
              vehRegNo: vehicle,
              date: group[0].date,
              checkInID: group[0].checkInID,
            }
            arr.push(obj);
          }
        }
        let apiObj = {
          type: "Unassign",
          // "checkInOutID":this.checkInOutID,
          vehUpdate: arr,
          rosterID: rosterIDs,
          branchInfo: this.branchInfo,
          tripDate: this.selTripDate
        }
        // if(this.selFilteredDate==undefined){
        //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
        // }else{
        //   apiObj['tripDate']=this.selFilteredDate;
        // }

        this.api.transportManagerEditGrouping(apiObj).then((res: any) => {
          if (res && res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 5000);
            
            // Store unassigned group and vehicle info to add back to modal lists
            const unassignedGroups = [];
            const unassignedVehicles = [];
            
            for (let i = 0; i < rosterIDs.length; i++) {
              let group = this.routingData.filter(e => e.rosterID == rosterIDs[i]);
              if (group.length > 0) {
                // Store group info
                unassignedGroups.push({
                  ...group[0],
                  assign: false // Mark as unassigned
                });
                
                // Store vehicle info
                if (group[0].vehRegNo) {
                  if (this.vehicleCheckIn) {
                    let vehicleData = this.allCheckInVeh.filter(e => e.vehRegNo == group[0].vehRegNo);
                    if (vehicleData.length > 0) {
                      unassignedVehicles.push({
                        ...vehicleData[0],
                        assign: false
                      });
                    }
                  } else {
                    // For non-check-in vehicles, find from allVehicles or allNewVehicleList
                    let vehicleData = this.allNewVehicleList.filter(v => v.vehRegNo == group[0].vehRegNo);
                    if (vehicleData.length > 0) {
                      unassignedVehicles.push({
                        ...vehicleData[0],
                        assign: false
                      });
                    }
                  }
                }
              }
            }
            
            this.selectedGroupsObj = {};
            this.groupWithVehObj = {};
            this.groupWithoutVehObj = {};
            this.mergeDataAreas = {};
            this.addEmpData = [];
            this.availableEmpInGroups = [];
            this.disableUnassign = true;
            
            if (this.vehicleCheckIn) {
              this.getVehicleCheckInList();
            } else {
              this.getVehicleList();
            }
            
            if (this.selFilteredDate == undefined) {
              this.getEmployeeList();
            } else {
              this.getEmployeeList(this.selFilteredDate);
            }
            
            // After data refresh, add unassigned items back to modal lists
            setTimeout(() => {
              // Add unassigned groups back to modal lists
              for (let group of unassignedGroups) {
                const existingGroup = this.modalGroupsData.find(g => g.rosterID === group.rosterID);
                if (!existingGroup) {
                  this.modalGroupsData.push(group);
                }
              }
              this.filteredModalGroups = [...this.modalGroupsData];
              
              // Add unassigned vehicles back to modal lists
              for (let vehicle of unassignedVehicles) {
                const existingVehicle = this.allNewVehicleList.find(v => v.vehRegNo === vehicle.vehRegNo);
                if (!existingVehicle) {
                  this.allNewVehicleList.push(vehicle);
                }
                
                const existingCab = this.allCabs.find(v => v.vehRegNo === vehicle.vehRegNo);
                if (!existingCab) {
                  this.allCabs.push(vehicle);
                }
              }
              this.filteredCabs = [...this.allCabs];
            }, 100);
          } else {
            this.swal.swalFunction('error', res.status, res.message, 5000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });

  }

  formatDate(date) {
    var today: any = date;
    var dd: any = today.getDate();
    var mm: any = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd;
    return today;
  }

  showNestedData(id) {
    setTimeout(() => {
      let btn = document.getElementById(id);
      if (btn.classList.contains('fa-chevron-down')) {
        btn.classList.replace('fa-chevron-down', 'fa-chevron-up');
        btn.title = 'Hide employee';
      } else {
        btn.classList.replace('fa-chevron-up', 'fa-chevron-down');
        btn.title = 'Show employee';
      }
    }, 100)
  }
  removeDuplicates(arr, name) {
    let x = [];
    const unique = arr.filter(element => {
      const isDuplicate = x.includes(element[name]);

      if (!isDuplicate) {
        x.push(element[name]);

        return true;
      } else {
        return false;
      }
    });
    return unique;
  }
  public checkedEscorts: any = [];
  getEscortCheckInOutList() {
    let today = new Date().setHours(0, 0, 0, 0);
    let currentDate = new Date();
    let date = new Date(currentDate);
    date.setDate(date.getDate() - 1);
    let previousDate = date.getTime();
    let yesterday = new Date(previousDate).setHours(0, 0, 0, 0);
    let obj = {
      date: [yesterday, today],
      branch: this.choosenBranch[0]
    }
    if (this.escortCheckIn) {
      this.api.transportManagerEscortCheckInOutList(obj).then((res: any) => {
        if (res && res.status == 'success' && res.data && res.data.length > 0) {
          this.checkedEscorts = res.data;
          this.checkInEscort = res.data.filter(e => e.type == 'in' && !e.routeAssign);
          // this.escortCheckInOutID=res['data'][0]['checkInOutID'];
        } else {
          this.checkInEscort = [];
          this.escortCheckInOutID = '';
        }
        this.availableEscort = this.checkInEscort;
      }).catch((err) => {
        console.log(err);
      });
    } else if (!this.escortCheckIn) {
      this.api.transpportManagerAllEscortList('').then((res: any) => {
        if (res.status == 'success') {
          this.checkedEscorts = res.data;
          this.checkInEscort = res.data;
          this.checkInEscort.filter(e => {
            // e.checkIndate = new Date() 
          })
        } else {
          this.checkInEscort = [];
        }
        this.availableEscort = this.checkInEscort;
      }).catch((err) => {
        console.log(err);
      })
    }

  }
  addOrRemoveEscortToRoute(group) {
    this.selectedRoute = group;
    if (group.escortInfo) {
      this.selectedEscort = this.checkedEscorts.filter(e => e.name == group.escortInfo.name && e.mobile == group.escortInfo.mobile);
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to unassign this escort from this route!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#4caf50 ',
        confirmButtonText: 'Confirm',
        customClass: {
          cancelButton: 'order-1',
          confirmButton: 'order-2',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let obj = {
            "type": "Escort unassign",
            "rosterID": this.selectedRoute.rosterID,
            "tripDate": this.selectedRoute.tripDate,
            // "checkInDate":this.selectedEscort[0].checkInDate,
            "branchInfo": this.branchInfo,
            "escortInfo": {
              "escortCheckInID": this.selectedEscort[0].escortCheckInID,
            }
          }
          if (this.escortCheckIn == true) {
            obj['escortInfo']['escortCheckInID'] = this.selectedEscort[0].escortID;
          } else if (!this.escortCheckIn) {
            obj['escortInfo']['escortCheckInID'] = this.selectedEscort[0]._id;
          }
          this.api.transportManagerEditGrouping(obj).then((res: any) => {
            if (res && res.status == 'success') {
              this.swal.swalFunction('success', res.status, res.message, 5000);
              this.closeEscortAssign();
              if (this.selFilteredDate == undefined) {
                this.getEmployeeList();
              } else {
                this.getEmployeeList(this.selFilteredDate);
              }
            } else {
              this.swal.swalFunction('error', res.status, res.message, 5000);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      });
    } else {
      this.getEscortCheckInOutList();
      document.getElementById('openEscortAssignBtn')?.click();
    }
  }
  onSearchChange(searchValue) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
    let data = this.checkInEscort.filter(e => e.name.toLowerCase().includes(searchValue.toLowerCase()));
    this.availableEscort = data;
  }
  public selectedEscort: any = [];
  public selectedRoute: any = {};
  selectEscort(value, escort) {
    if (this.escortCheckIn) {
      if (this.selectedEscort.length > 0) {
        let index = this.selectedEscort.findIndex(e => e.escortID == escort.escortID);
        if (index != -1) {
          this.selectedEscort.splice(index, 1);
        } else {
          this.selectedEscort.push(escort);
        }
      } else {
        this.selectedEscort.push(escort);
      }
      let index = this.availableEscort.findIndex(e => e.escortID == escort.escortID);
      if (index != -1) {
        this.availableEscort[index]['checked'] = value;
      }
    }
    if (!this.escortCheckIn) {
      if (this.selectedEscort.length > 0) {
        let index = this.selectedEscort.findIndex(e => e._id == escort._id);
        if (index != -1) {
          this.selectedEscort.splice(index, 1);
        } else {
          this.selectedEscort.push(escort);
        }
      } else {
        this.selectedEscort.push(escort);
      }
      let index = this.availableEscort.findIndex(e => e._id == escort._id);
      if (index != -1) {
        this.availableEscort[index]['checked'] = value;
      }
    }
  }
  closeEscortAssign() {
    this.selectedEscort = [];
    this.selectedRoute = {};
    this.availableEscort = [];
    this.checkInEscort = [];
    document.getElementById('closeEscortAssignBtn')?.click();
  }
  assignEscort() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to assign this escort to this route!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50 ',
      confirmButtonText: 'Confirm',
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          "type": "Escort assign",
          "escortInfo": {
            "name": this.selectedEscort[0].name,
            "mobile": Number(this.selectedEscort[0].mobile),
            // "escortID": this.selectedEscort[0].escortID,
            "escortCheckInID": this.selectedEscort[0]['escortCheckInID']
          },
          "rosterID": this.selectedRoute.rosterID,
          "tripDate": this.selectedRoute.tripDate,
          // "escortID": this.selectedEscort[0].escortID,
          // "checkInDate":this.selectedEscort[0].checkInDate,
          "branchInfo": this.branchInfo
        }
        if (this.escortCheckIn) {
          obj['escortInfo']['escortID'] = this.selectedEscort[0].escortID;
          obj['escortID'] = this.selectedEscort[0].escortID
        } else if (!this.escortCheckIn) {
          obj['escortInfo']['escortID'] = this.selectedEscort[0]._id,
            obj['escortID'] = this.selectedEscort[0]._id
        }
        this.api.transportManagerEditGrouping(obj).then((res: any) => {
          if (res && res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 5000);
            this.closeEscortAssign();
            if (this.selFilteredDate == undefined) {
              this.getEmployeeList();
            } else {
              this.getEmployeeList(this.selFilteredDate);
            }
          } else {
            this.swal.swalFunction('error', res.status, res.message, 5000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }


  //Add employee to route
  public groupingEmps: any = [];
  public availableGroupEmps: any = [];
  public storedGroupEmps: any = [];
  public showEmpTable: boolean = false;
  public addEmpGroup: any = {};
  public selectedEmployees: any = [];
  public availableSeats: number = 0;
  findGroupEmps(data) {
    if (data && data.length > 0) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        if (this.addEmpGroup.tripDate == data[i].tripDate && this.addEmpGroup.transitMode == data[i].transitMode) {
          for (let j = 0; j < data[i]['empInfo'].length; j++) {
            data[i]['empInfo'][j]['oldRosterID'] = data[i]['rosterID'];
          }
          arr = [...arr, ...data[i]['empInfo']];
        }
      }
      this.groupingEmps = arr;
      this.showEmpTable = true;
    } else {
      this.groupingEmps = [];
    }
    this.availableGroupEmps = this.groupingEmps;
  }
  public addEmployeeTripDate = '';
  openAddEmp(group, seats?) {
    this.availableSeats = seats;
    this.addEmpGroup = group;
    this.addEmployeeTripDate = group.tripDate;
    this.findGroupEmps(this.storedGroupEmps);
    document.getElementById('openEmployeeAddBtn')?.click();
  }
  closeEmployeeAdd() {
    for (let i = 0; i < this.groupingEmps.length; i++) {
      if (this.groupingEmps[i].checked != undefined) delete this.groupingEmps[i].checked;
    }
    this.addEmployeeTripDate = '';
    this.availableSeats = 0;
    this.selectedEmployees = [];
    this.addEmpGroup = {};
    this.showEmpTable = false;
    this.groupingEmps = [];
    this.availableGroupEmps = [];
    // document.getElementById('closeEmployeeAddBtn')?.click();
  }
  customiseFinalObj() {
    return new Promise((res, rej) => {
      let checkedEmp = this.availableGroupEmps.filter(e => e.checked);
      let allEmps = [...checkedEmp, ...this.addEmpGroup['empInfo']];
      let apiObj = {
        rosterID: this.addEmpGroup.rosterID,
        empInfo: allEmps,
        removeEmp: [],
        tripDate: this.addEmployeeTripDate
      };
      // if(this.selFilteredDate==undefined){
      //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
      // }else{
      //   apiObj['tripDate']=this.selFilteredDate;
      // }
      let removeObj = [];
      for (let i = 0; i < checkedEmp.length; i++) {
        let cusObj = {
          empRefID: [checkedEmp[i].empRefID],
          oldRosterID: checkedEmp[i].oldRosterID
        }
        let index = removeObj.findIndex(e => e.oldRosterID == checkedEmp[i].oldRosterID);
        if (index != -1) {
          removeObj[index].empRefID.push(checkedEmp[i].empRefID);
        } else {
          removeObj.push(cusObj);
        }
      }
      apiObj['removeEmp'] = removeObj;
      res(apiObj);
    })
  }
  async addEmployeeToRoute() {
    let obj = await this.customiseFinalObj();
    this.api.transportManagerRosterAddEmployee(obj).then((res: any) => {
      if (res && res.status == 'success') {
        this.swal.swalFunction('success', res.status, res.message, 5000);
        this.closeEmployeeAdd();
        document.getElementById('closeEmployeeAddBtn')?.click();
        if (this.selFilteredDate == undefined) {
          this.getEmployeeList();
        } else {
          this.getEmployeeList(this.selFilteredDate);
        }
      } else {
        this.swal.swalFunction('error', res.status, res.message, 5000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  findEmployee(searchValue) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
    let data = this.groupingEmps.filter(e => e.name.toLowerCase().includes(searchValue.toLowerCase()) || e.empRefID.toLowerCase().includes(searchValue.toLowerCase()));
    this.availableGroupEmps = data;
  }
  selectAddEmployee(value, employee) {
    let index1 = this.availableGroupEmps.findIndex(e => e.employeeID == employee.employeeID);
    if (index1 != -1) {
      this.availableGroupEmps[index1]['checked'] = value;
    }
    this.selectedEmployees = this.availableGroupEmps.filter(e => e.checked);
  }
  reOrderGroup(group) {
    this.reOrderGrp = { ...group };
    this.reOrderGrp['reOrder'] = false;
    // Deep copy each object inside empInfo array
    this.reOrderArr = this.reOrderGrp.empInfo.map(item => JSON.parse(JSON.stringify(item)));
  }
  onDrop(event: CdkDragDrop<any[]>) {

    const prevIndex = this.reOrderArr.findIndex((item) => item === event.item.data);
    const currentIndex = event.currentIndex;

    if (prevIndex !== currentIndex) {
      const movedItem = this.reOrderArr.splice(prevIndex, 1)[0];
      this.reOrderArr.splice(currentIndex, 0, movedItem);
      this.reOrderGrp['reOrder'] = true;
      this.reOrderGrp['type'] = 'reOrder';
      this.reOrderGrp['empInfo'] = [...this.reOrderArr];
    }
  }
  submitReorder() {

    let obj = {
      'empInfo':this.reOrderGrp['empInfo'],
      'type':this.reOrderGrp['type'],
      'rosterID':this.reOrderGrp['rosterID'],
    };
    
    this.api.transportManagerEditGrouping(obj).then((res: any) => {
      if (res && res.status == 'success') {
        this.getEmployeeList();
        this.reOrderModalClose.nativeElement.click();        
        this.swal.swalFunction('success', res.status, res.message, 5000);
      } else {
        this.swal.swalFunction('error', res.status, res.message, 5000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
